import React from 'react'
import PropTypes from 'prop-types'
import Link from 'gatsby-link'
import styles from './Pagination.module.css'

const Pagination = ({ context }) => {
  const { numPages, currentPage } = context
  const isFirst = currentPage === 1
  const isLast = currentPage === numPages
  const isNotPaginated = isFirst && isLast

  const prevPageNum = currentPage - 1 === 1 ? `` : currentPage - 1
  const nextPageNum = currentPage + 1

  const pathPrefix = '/blog'
  let prevPageLink = isFirst ? pathPrefix : `${pathPrefix}/${prevPageNum}/`
  if (prevPageNum === '') {
    prevPageLink = pathPrefix
  }
  const nextPageLink = isLast ? null : `${pathPrefix}/${nextPageNum}/`

  return (
    <div className={styles.paginationWrapper}>
      {!isFirst && (
        <Link className={styles.previousLink} to={prevPageLink}>
          &#8592; Prev Page
        </Link>
      )}
      {!isNotPaginated && (
        <span className={styles.pageIndicator}>
          {currentPage} / {numPages}
        </span>
      )}
      {!isLast && (
        <Link className={styles.nextLink} to={nextPageLink}>
          Next Page &#8594;
        </Link>
      )}
    </div>
  )
}

Pagination.propTypes = {
  context: PropTypes.shape({
    limit: PropTypes.number,
    skip: PropTypes.number,
    numPages: PropTypes.number,
    currentPage: PropTypes.number,
  }),
}

export default Pagination
